import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/home'
import Success from '../views/success'

import store from '@/store'
import { noop } from '@/utils'

const routes = [
	{
		path: '/success',
		name: 'success',
		component: Success,
		meta: {
			title: ''
		}
	},
	{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: {
			title: '',
			tabbar: true
		}
	}
	// {
	// 	path: '/alipay',
	// 	name: 'alipay',
	// 	component: Alipay,
	// 	meta: {
	// 		title: '',
	// 		tabbar: true
	// 	}
	// }
	// {
	// 	path: '/feedback',
	// 	name: 'feedback',
	// 	component: () => import('../views/feedback.vue'),
	// 	meta: {
	// 		title: '问题反馈'
	// 	}
	// }
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

const whiteList = ['/login', '/smsCode']

router.beforeEach(async (to, from, next) => {
	// if (to.query.distributorId && !whiteList.includes(to.path)) {
	// 	localStorage.clear()
	// 	next('/login?distributorId=' + to.query.distributorId)
	// }

	// if (whiteList.includes(to.path)) {
	// 	next()
	// 	return
	// }

	// const { userInfo, token } = store.getters
	// if (!userInfo && token) {
	// 	await store.dispatch('getUserInfo').catch(noop)
	// }
	// if (!store.getters.userInfo) {
	// 	next('/login')
	// } else {
	// 	to.path == '/login' ? next('/') : next()
	// }

	next()
})

router.afterEach((to) => {
	// if (!whiteList.includes(to.path) && !store.getters.userInfo.name) {
	// 	store.dispatch('showUserForm')
	// }
	sensors.quick('autoTrackSinglePage')
})

export default router
